// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1s08b","comment":"styles_comment__2vrH-"};